import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './baseQuery';

export const materialsApi = createApi({
  reducerPath: 'materialsApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Materials'],
  endpoints: (builder) => ({
    getMaterials: builder.query({
      query: (params) => ({
        url: '/materials',
        params: {
          search: params?.search,
          type: params?.type,
          genre: params?.genre,
          country: params?.country,
          year: params?.year,
          drama_status: params?.drama_status,
          sort_by: params?.sort_by,
          sort_order: params?.sort_order,
          page: params?.page,
          per_page: params?.per_page,
        },
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ id }) => ({ type: 'Materials', id })),
              { type: 'Materials', id: 'LIST' },
            ]
          : [{ type: 'Materials', id: 'LIST' }],
    }),

    getMaterialById: builder.query({
      query: (id) => `/materials/${id}`,
      providesTags: (result, error, id) => [{ type: 'Materials', id }],
    }),

    getMaterialBySlug: builder.query({
      query: ({ slug, slugId }) => `/materials/slug/${slug}/${slugId}`,
      providesTags: (result) =>
        result?.data ? [{ type: 'Materials', id: result.data.id }] : [],
    }),
  }),
});

export const {
  useGetMaterialsQuery,
  useGetMaterialByIdQuery,
  useGetMaterialBySlugQuery,
} = materialsApi;
